/* eslint-disable @typescript-eslint/dot-notation */
import { Component, ViewEncapsulation, ElementRef, ViewChild, AfterViewChecked } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { BoolEditor, MatColor } from '../../models/commons.enum';
import { ICellRendererParams } from 'ag-grid-community';
import { FormControl, FormGroup } from '@angular/forms';

/**
 * Editor Custom AgGrid for Booleans Input.
 * Params:
 * - color: (Optional) it allows to specify witch standard material color  to apply  'PRIMARY' 'ACCENT', 'WARN'.
 * - editor (Default true) it allows to specify witch material component to show, 'CHECKBOX' or 'SLIDETOGGLE.
 * - required: (Optional) It allows to specify required validator.
 */
@Component({
    selector: 'se-boolean-cell-renderer',
    templateUrl: './boolean-cell-renderer.component.html',
    styleUrls: ['./boolean-cell-renderer.component.scss'],
    encapsulation: ViewEncapsulation.None

})

export class BooleanCellRendererComponent implements ICellRendererAngularComp, AfterViewChecked {
    /**
     * (Optional) it allows to specify witch standard material color  to apply  'PRIMARY' 'ACCENT', 'WARN'.
     */
    public color: MatColor;
    public editor: BoolEditor;
    public disabled: boolean;

    public checked: boolean;
    public isEditor: boolean;
    public isRequired: boolean;
    @ViewChild('toggleElement', { static: false, read: ElementRef }) toggleElement: ElementRef;

    // -------
    formGroup: FormGroup;
    key;
    columnName: string;
    // -------

    private params: ICellRendererParams;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.checked = this.params.value;
        this.disabled = this.params['disabled'] || false;
        this.color = (this.params['color'] || MatColor.PRIMARY).toLowerCase();
        this.editor = this.params['editor'] || BoolEditor.CHECKBOX;
        this.isEditor = this.params['isEditor'] || false;
        this.isRequired = this.params['required'] || false;

        // ------ validazione
        this.columnName = params.colDef.headerName;
        this.key = params.context.createKey(params.node, params.column); 
        // ------
    }

    ngAfterViewChecked() {
        this.formGroup = this.params.context.formGroup;
        if (!this.formGroup.controls[this.key]) {
            this.formGroup.addControl(this.key, new FormControl(this.checked));
        }
        if (this.isEditor) {
            this.toggleElement.nativeElement.firstElementChild.firstElementChild.focus();
        }
    }

    _onChange(event) {
        this.checked = event;
        let colId = this.params.column.getId();
        this.params.node.setDataValue(colId, this.checked);
        this.formGroup.controls[this.key].setValue(this.checked);
    }

    refresh(params: ICellRendererParams): boolean {
        this.checked = params.value;
        return true;
    }

    getValue(): any {
        if (this.formGroup.controls[this.key] && !this.formGroup.controls[this.key].invalid) {
            return this.formGroup.controls[this.key];
        }
        return null;
    }
}
